import { message } from 'antd';
import * as ACTIONS from 'app/actions/DailyComplianceActions';

const initialState = {
    isLoadListCompliance: false,
    listCompliance: [],

    filter: {
        complianceDate: ''
    },

    pagination: {
        current: 1,
        pageSize: 25,
        total: 0,
        column: '',
        order: ''
    },

    isLoadExport: false
}

export const DailyComplianceReducer = (state = initialState, action) => {
    switch (action.type) {
        //Obtiene cumplimiento diario
        case ACTIONS.FETCH_DAILY_COMPLIANCE_REQUEST:
            return {
                ...state,
                isLoadListCompliance: true
            }
        case ACTIONS.FETCH_DAILY_COMPLIANCE_SUCCESS:
            return {
                ...state,
                isLoadListCompliance: false,
                listCompliance: action.payload,
                pagination: {
                    ...state.pagination,
                    total: action.payload.length > 0 ? action.payload[0].totalCount : 0,
                }
            }
        case ACTIONS.FETCH_DAILY_COMPLIANCE_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadListCompliance: false
            }

        //Guarda los filtros
        case ACTIONS.SAVE_FILTER:
            return {
                ...state,
                filter: action.payload
            }

        //Guarda el paginador
        case ACTIONS.SAVE_PAGINATION:
            return {
                ...state,
                pagination: action.payload
            }

        //Exporta los datos
        case ACTIONS.EXPORT_DAILY_COMPLIANCE_REQUEST:
            return {
                ...state,
                isLoadExport: true
            }
        case ACTIONS.EXPORT_DAILY_COMPLIANCE_SUCCESS:
            return {
                ...state,
                isLoadExport: false
            }
        case ACTIONS.EXPORT_DAILY_COMPLIANCE_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadExport: false
            }
        //Limpia el reducer
        case ACTIONS.CLEAR_REDUCER:
            return initialState;

        default:
            return state;
    }
}